import { render, staticRenderFns } from "./Auskunft.vue?vue&type=template&id=3e7dd435&scoped=true&"
import script from "./Auskunft.vue?vue&type=script&lang=js&"
export * from "./Auskunft.vue?vue&type=script&lang=js&"
import style0 from "./Auskunft.vue?vue&type=style&index=0&id=3e7dd435&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7dd435",
  null
  
)

export default component.exports